import { TextField } from '@material-ui/core';
import { Controller } from 'react-hook-form';

/**
 * @param {import('@material-ui/core').TextFieldProps & {
 *  name: string; control: any;
 *  error?: boolean; rules?: import('react-hook-form').RegisterOptions;
 * }} param0
 */
const FormTextField = ({
    name,
    control,
    rules,
    onChange: valueChanged,
    ...props
}) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
            field: {
                onChange, onBlur, value, ref,
            },
        }) => (
            <TextField
                {...props}
                value={value}
                ref={ref}
                onBlur={onBlur}
                onChange={(event) => {
                    onChange(event);
                    if (valueChanged) {
                        valueChanged(event);
                    }
                }}
            />
        )}
    />
);

export default FormTextField;
